<template>
  
  <div class="ui cards">
    <animal-card v-for="(animal, index) in animals" :animal="animal" :key="index" 
      @onUpdate="fetchData()" @onUpdateOwner="$emit('onUpdateOwner')" />
  </div>

</template>

<script>

  import AnimalCard from "./card.vue"

  export default {
    
    name: "AnimalCardList",

    data() {
      return {
        animals: [],
      }
    },

    props: {
      fetcher: { type: Function, required: true },
    },

    components: {
      AnimalCard,
    },

    methods: {

      fetchData() {
        this.animals = []
        setTimeout(this.runFetcher, 15)  
      },

      async runFetcher() {

        this.animals = []
        
        try {
          this.animals = await this.fetcher()                    
        } catch (error) {
          this.$errorHandler(error)
        }
      },
    },
  }

</script>